import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { License } from '../../shared/model/license.model';
import { PeopleModel } from '../../shared/model/peopleModel.model';
import { HttpErrorHandler } from '../../shared/services/error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {

  headers: HttpHeaders;
  apiServer: string;


  constructor(private http: HttpClient, private apiRef: ApiProviderService, private errorHandler: HttpErrorHandler) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    this.apiServer = 'api/Licenses/';
   }

   validateLicenseLink(licenseLink: License): Observable<License> {

    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}lookup`,[
        {Key: 'licenseNum', Value: licenseLink.licenseNum},
        {Key: 'licenseType', Value: licenseLink.licenseType},
      ]))
      .pipe(map(resp => {
        if(resp && resp!=='null'){
          return resp['result'] as License;
        } else {
          return null;
        }
      }));

   }
}
